import { Box } from '@mui/material';

import { ILazyDropdownOption, LazyDropdown } from 'components/lazyDropdown/LazyDropdown';
import { useGetWellsByTerm } from '../api/useCompositeProfileController';

interface IWellLazyDropdownProps {
    value: ILazyDropdownOption<string> | null;
    onChange: (option: ILazyDropdownOption<string> | null) => void;
    className?: string;
    label?: string;
    disabled?: boolean;
}

export function WellLazyDropdown({ value, onChange, className, label = 'Well', disabled }: IWellLazyDropdownProps) {
    const { fetchWells } = useGetWellsByTerm();

    return (
        <Box className={className}>
            <LazyDropdown<string>
                value={value}
                onChange={onChange}
                fetchOptions={fetchWells}
                label={label}
                disabled={disabled}
            />
        </Box>
    );
}
